import  React, { useState} from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';


export default function DropdownList(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [behavior, setBehavior] = useState(props.behavior);

  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, option) => {
    setBehavior(option);
    props.setBehavior(option);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <List
        component="nav"
        aria-label="Device settings"
      >
        <ListItem
          button
          id="lock-button"
          aria-haspopup="listbox"
          aria-controls="lock-menu"
          aria-label="when device is locked"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClickListItem}
        >
          <span style={{
                backgroundColor: behavior.Color,
                color: '#fff',
                padding: "2px 9px",
                borderRadius: "50%"
            }}>&nbsp;</span> <span>&nbsp;{behavior.Name}</span>
        </ListItem>
      </List>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'lock-button',
          role: 'listbox',
        }}
      >
        {props.behaviors.map((option, index) => (
          <MenuItem
            key={option.Label}
            selected={option.Label === behavior.Label}
            onClick={(event) => handleMenuItemClick(event, option)}>
            <span style={{
                backgroundColor: option.Color,
                color: '#fff',
                padding: "2px 12px",
                borderRadius: "50%"
            }}>&nbsp;</span> <span>&nbsp;{option.Name}</span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
